import React from 'react';

import RoundedContainer from './roundedContainer';
import CTAButton from './ctaButton';
import DividerLine from './dividerLine';

const BlockSelection = ({ ...props }) => {
    
    return (
        <RoundedContainer className="flex flex-wrap">
            <h3 className="text-red-500 font-bold text-lg lg:text-2xl w-full">{props.title}</h3>
            <p className="text-md lg:text-lg w-full">{props.description}</p>
            <DividerLine horizontal={true} dashed={true} />
            
            <CTAButton 
                onButtonClick={props.onButtonClick}
                text={
                    props.buttonDisabled
                        ? props.buttonDisabledText
                        : props.buttonToggled
                        ? props.buttonToggleText
                        : props.buttonText
                }
            />
        </RoundedContainer>
    );
};
export default BlockSelection;